import { FetchError } from 'ofetch';

export const parseError = (
  error: unknown,
): { title: string; message: string } => {
  let title = 'Error';
  let message = 'An unexpected error occurred.';
  const findErrorMessage = (res: unknown): string | null => {
    if (typeof res === 'string' && res) {
      return res;
    }
    if (typeof res === 'object' && Array.isArray(res) && res.length) {
      return findErrorMessage(res[0]);
    }
    if (typeof res === 'object' && res) {
      return 'message' in res
        ? findErrorMessage(res.message)
        : 'detail' in res
          ? findErrorMessage(res.detail)
          : 'error' in res
            ? findErrorMessage(res.error)
            : 'errors' in res
              ? findErrorMessage(res.errors)
              : null;
    }
    return null;
  };
  try {
    if (error instanceof FetchError) {
      title = `Request Error: ${error.status || 'unknown'}`;
      message = error.statusText || message;
      if (error.status && error.status >= 500) {
        return { title, message };
      }
      try {
        if (error.status !== 404) {
          message = findErrorMessage(error.data) || message;
        }
      } catch {}
    } else if (error instanceof Error) {
      title = error.name || title;
      message = error.message || message;
    } else {
      message = findErrorMessage(error) || message;
    }
    return { title, message };
  } catch {
    return { title, message };
  }
};
